
import CategoriesFilter from "~/components/filters/CategoriesFilter.vue";
import PriceFilter from '~/components/filters/PriceFilter.vue'
import SquareFilter from '~/components/filters/SquareFilter.vue'
import { CmsMixin } from '~/node_modules/sitis-nuxt/lib/mixins';

export default {
  name: 'Filters',
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    filterPrice: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selectedFilters: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  mixins: [
    CmsMixin
  ],
  emits: [
    'requestUpdateFilter',
    'nullingFilters'
  ],
  data: function () {
    return {
      filterPrices: {...this.filterPrice},
      // filterSelected: {...this.selectedFilters},

      filterSquare: {},
    }
  },
  components: {
    CategoriesFilter,
    PriceFilter,
    SquareFilter
  },
  computed: {
    isShowFilterPrice: function () {
      return Boolean(Object.keys(this.filterPrice || {}).length > 0)
    },
    isShowFilterSquare: function () {
      return Boolean(Object.keys(this.filterSquare || {}).length > 0)
    },
    // isSelectedSquare: function () {
    //   return this.selectedFilters?.['plosad']?.[0]?.split(':');
    // },
    planirovkiFromMenu() {
      return this.getCmsMenu('default')?.items?.find(item => item.alias === 'planirovki')?.children || []
    },
    isShowClearFiltersButton() {
      return Boolean(Object.keys(this.selectedFilters || {}).length > 0)
    },
    squareForWatching() {
      return this.filters.find(item => item.slug === 'plosad') || {};
    }
  },
  methods: {
    changeFilterPrices: function (range) {
      let newSelectedPrices = [...(this.filterPrices?.selectedPrices || [])]
      newSelectedPrices[0] = range[0]
      newSelectedPrices[1] = range[1]
      this.filterPrices.selectedPrices = newSelectedPrices;

      let filterSelected = { ...this.selectedFilters };
      if (!!range[0]) {
        filterSelected['priceFrom'] = {
          [range[0]]: range[0]
        };
      } else {
        delete filterSelected['priceFrom']
      }
      if (!!range[1]) {
        filterSelected['priceTo'] = {
          [range[1]]: range[1]
        };
      } else {
        delete filterSelected['priceTo']
      }
      this.$emit('requestUpdateFilter', filterSelected)
    },
    changeFilterSquare: function(range) {
      let newSelectedSquares = [...(this.filterSquare?.selectedSquares || [])]
      newSelectedSquares[0] = range[0]
      newSelectedSquares[1] = range[1]
      this.filterSquare.selectedSquares = newSelectedSquares;

      let filterSelected = { ...this.selectedFilters };
      if (!!range[0] || !!range[1]) {
        const _startParam = range[0] || this.filterSquare.minSquare;
        const _endParam = range[1] || this.filterSquare.maxSquare;

        filterSelected['plosad'] = {
          [`${_startParam}:${_endParam}`]: `${_startParam}:${_endParam}`
        }
      }
      this.$emit('requestUpdateFilter', filterSelected)
    },
    changeFilterCategory: function (newCategory) {
      const pathname = window.location.pathname;

      const nuxtFilter = String(String(pathname || '').split('/f/')?.pop() || '').split('?')?.[0] || ''; // если надо передать фильтры
      const categoryPath = newCategory?.alias;
      if (categoryPath === 'vse-planirovki') {
        this.$router.push('/apartments')
        return
      }

      const newPath = [
        categoryPath,
        // nuxtFilter // если надо передать фильтры, отключил, т.к при смене категории они тоже изменяются (сумма, площадь)
      ].filter((t) => !!t).join('/f/');
      this.$router.push(`/planirovki/${ newPath }`);
    },
    initFilterSquare: function () {
      const _squareFilter = this.filters.find(item => item.slug === 'plosad');

      const _minSquare = Number(_squareFilter?.variants?.[0].label);
      const _maxSquare = Number(_squareFilter?.variants?.[_squareFilter?.variants?.length - 1].label);

      this.filterSquare = {
        minSquare: _minSquare,
        maxSquare: _maxSquare
      }
      console.log('')
    },
    handleClearFilters: function () {
      this.$emit('nullingFilters')
    }
  },
  watch: {
    squareForWatching(newVal, oldVal) {
      if (newVal.variants?.[0] === oldVal.variants?.[0]) {
        return
      } else {
        this.initFilterSquare()
      }
    }
  },
  mounted() {
    this.initFilterSquare();
  }
}
